export function isHtml(value: string): boolean {
	return value.includes('</html>');
}
